import Toggle from "app/components/Toggle";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { selectCompanySettings, updateCompanySettings } from "./slice";
import { useAppDispatch, useAppSelector } from "utils/redux/hooks";
import { CompanySettings } from "./types";
import { useDebounceCallback } from "utils/hooks";

const EPPAdminConsoleSettings = () => {
  const dispatch = useAppDispatch();
  // ------------------------ Selectors ------------------------------------
  const companySettings = useAppSelector(selectCompanySettings);
  // ------------------------ States ------------------------------------
  const [allowUsersToLinkPreviousResults, setAllowUsersToLinkPreviousResults] =
    useState(false);
  // ------------------------ Use Effects ------------------------------------
  useEffect(() => {
    setAllowUsersToLinkPreviousResults(!!companySettings?.linkResultsAccess);
  }, [companySettings?.linkResultsAccess]);
  // ------------------------- Callbacks ------------------------------------
  const onSaveCompanySettings = useDebounceCallback(
    (value: CompanySettings["linkResultsAccess"]) => {
      const companyAccountId = companySettings?.companyAccountId;
      if (!companyAccountId) {
        return;
      }

      dispatch(
        updateCompanySettings({
          payload: { linkResultsAccess: value },
          companyAccountId: companyAccountId,
        })
      );
    },
    1000
  );

  return (
    <Card className="admin-console-settings-card">
      <div>
        <h2 id="visibility-settings">EPP</h2>
        <p>Settings related to the Employee Personality Profile (EPP).</p>
      </div>
      <div className="setting-row">
        <div className="setting-row-description">
          <h3>Allow Users to Link Previous Results</h3>
          <p>
            Any user can link results that they've previously completed with
            their organization to their employee profile.
          </p>
        </div>
        <div className="setting-row-action">
          <Toggle
            isOn={allowUsersToLinkPreviousResults}
            handleToggle={() => {
              setAllowUsersToLinkPreviousResults(
                !allowUsersToLinkPreviousResults
              );
              onSaveCompanySettings(allowUsersToLinkPreviousResults ? 0 : 1);
            }}
          />
        </div>
      </div>
    </Card>
  );
};

export default EPPAdminConsoleSettings;
